<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-container.d-flex.justify-content-between(fluid)
      div.d-flex
        b-breadcrumb(:items="tree")
    b-row.search-form
      b-col.right-btns
        b-button-group.excel-btn-group(v-if="excelAdd")
          b-form-file.upload-input.mr-2(ref="excelUpload" :key="excelUploadKey" size="sm")
          b-button.mr-2(variant="secondary" size="sm" type="button" @click="excelSubmit") {{$t('enrollment')}}
          b-button.mr-2(
            variant="info"
            size="sm"
            type="button"
            :href="`${Form}/linkmemine_department_form_ko.xlsx`"
          ) {{$t('excel-form')}}
          b-button.mr-2(variant="danger" size="sm" type="button" @click="excelAdd = false") {{$t('cancel')}}
        b-button-group.excel-btn-group(v-else)
          b-button.mr-2(variant="secondary" size="sm" type="button" @click="handleAdd") {{$t('department_page.add_department')}}
          b-button.mr-2(variant="secondary" size="sm" type="button" @click="excelAdd = true") {{$t('department_page.bulk_add_department')}}
          b-button.delete-btn.mr-2(variant="danger" size="sm" type="button" @click="handleDel") {{$t('delete')}}
    b-card.table-card
      b-table(
        ref="grid"
        :fields="tableData.fields"
        :items="departmentList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        sort-by="part_name"
        :sort-desc="false"
        :empty-text="$t('no-content')"
        show-empty
        responsive
      )
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @change="selectAllRows" :indeterminate="isIndeterminate")
        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item._isSelected", @change="handleCheck(row.item)")
        template(v-slot:cell(part_name)="row")
          .edit
            b-btn(v-if="!row.item.edit" variant="link" :to="{name: 'department-sub', params: { groupFk: row.item.pk }}") {{row.item.part_name}}
            editable(
              name="part_name",
              :class="{ 'hidden': !row.item.edit }"
              :value="row.item.part_name"
              :wait="row.item.wait"
              :pk="row.item.pk"
              :limit="20"
              @changed="valueChange"
              @edit="check => row.item.edit = check"
            )
</template>

<script>
import _ from "lodash"
import { DepartmentsAPI, DepartmentExcelUploadAPI } from "@/api"
import Editable from "@/components/mixins/editable"
import XLSX from "xlsx"

export default {
  name: "department-component",
  props: {
    groupFk: {
      type: [String, Number],
    },
  },
  components: { Editable },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    departmentList() {
      let list = this.tableData.list.filter(item => item.part_name !== 'NoDepartment')
      if (this.groupFk) {
        list = _.filter(list, { parent_group_fk: parseInt(this.groupFk) })
      } else {
        list = _.filter(list, { parent_group_fk: "-" })
      }
      return list
    },
    tree() {
      let tree = []
      if (!this.tableData.list.length) return []
      const addTreeItem = pk => {
        let current = _.find(this.tableData.list, { pk })
        if (!current) return
        tree.unshift({
          text: current.part_name,
          to: { name: "department-sub", params: { groupFk: pk } },
        })
        if (current.parent_group_fk) addTreeItem(current.parent_group_fk)
      }
      if (this.groupFk) {
        addTreeItem(parseInt(this.groupFk))
      }
      tree.unshift({
        text: "ROOT",
        to: { name: "department" },
      })
      tree[0].text = this.$t('department_page.department_manage')
      return tree
    },
    excelUploadKey() {
      return Math.random()
    },
  },
  mounted() {
    this.fetchList()
  },
  data() {
    return {
      Form: `${this.AppState.Path.download}/form`,
      excelAdd: false,

      allSelected: false,
      checkedGroup: [],
      isIndeterminate: false,

      tableData: {
        fields: [
          { key: "check", label: "", sortable: false, thStyle: { width: "1%" } },
          { key: "part_name", label: this.$t('department_page.department_name'), sortable: false, thStyle: { width: "280px" } },
          { key: "leader_manager_name", label: this.$t('manager-id'), sortable: false, thStyle: { minWidth: "80%" } },
        ],
        list: [],
        pagination: {
          by: "part_name",
          limit: 1000,
          offset: 0,
          order: "asc",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
      groupOnPage: [],
    }
  },
  methods: {
    fetchList() {
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.request_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      DepartmentsAPI.get("", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(this.$t('response_error_server_error'))
        }

        this.tableData.list = objects.map(v => {
          v._isSelected = false
          v.wait = false
          v.edit = false
          return v
        })
        this.tableData.pagination.total = meta.total_count
      })
    },
    selectAllRows() {
      _.each(this.tableData.list, v => {
        v._isSelected = this.allSelected
        this.handleCheck(v)
      })

      if (this.checkedGroup.length == this.tableData.list.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    handleAdd() {
      const params = {
        context: { title: this.$t('department_page.add_department') },
        limit: 20,
        placeholder: "name",
        submit: {
          size: "sm",
          color: "primary",
          text: "create",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          const rootGroupFk = this.groupFk ? _.find(this.tableData.list, { pk: parseInt(this.groupFk) }).root_group_fk : undefined
          let params = {
            part_name: data,
            leader_manager_fk: null,
            flag_confirm: false,
            parent_group_fk: parseInt(this.groupFk),
            root_group_fk: rootGroupFk === "-" ? this.groupFk : rootGroupFk,
          }
          DepartmentsAPI.post("", params).then(res => {
            this.$awn.success(this.$t('department_page.department_created'))
            this.fetchList()
          })
        }
      })
    },
    handleDel() {
      if (this.checkedGroup.length === 0) {
        return this.$awn.warning(this.$t('toasts_message.select_department_to_delete'))
      }
      let params = {
        context: { title: this.$t('department_page.department_delete'), path: this.$t('department_page.confirm_department_delete') },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        const departmentPK = this.checkedGroup.map(e => e.pk)
        for (const pk of departmentPK) {
          DepartmentsAPI.delete(pk.toString()).then(() => {
            let index = _.findIndex(this.tableData.list, v => v.pk === pk)
            this.tableData.list.splice(index, 1)
          })
        }
        this.$awn.success(this.$t('department_page.department_deleted'))
        this.checkedGroup = []
        this.isIndeterminate = false
      })
    },
    handleCheck(item) {
      if (this.checkedGroup.some(v => v.pk === item.pk)) {
        const index = this.checkedGroup.findIndex(u => u.pk === item.pk)
        this.checkedGroup.splice(index, 1)
      }
      if (item._isSelected) {
        this.checkedGroup.push(item)
      }

      if (this.checkedGroup.length == this.tableData.list.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    valueChange(key, value, pk) {
      const params = {}
      params[key] = value
      DepartmentsAPI.put(`${pk}`, params).then(res => {
        const { status } = res.data
        if (status === 200) {
          _.find(this.tableData.list, { pk }).part_name = value
        }
      })
    },

    excelSubmit() {
      const header = [
        { key: "part_name", type: "string" },
        { key: "parent_part_name", type: null },
      ]

      const input = this.$refs.excelUpload
      const reader = new FileReader()
      reader.onload = e => {
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: "binary" })
        const result = []
        let shouldBreak = false

        for (const sheetName of wb.SheetNames) {
          const rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          for (const item of rowObj) {
            const returnStr = {}

            for (const [i, key] of Object.keys(item).entries()) {
              if ((header[i].type === "string" && _.isEmpty(String(item[key]).trim())) || (header[i].type === "number" && _.isNaN(item[key]))) {
                this.$awn.warning(this.$t('toasts_message.key_is_required', {key: key}))
                shouldBreak = true
                break
              } else if (header[i].type === "enum" && !header[i].enum.includes(String(item[key]).trim())) {
                // this.$awn.warning(`${key}은(는) [${header[i].enum.join(", ")}] 값만 사용할수 있습니다.`)
                this.$awn.warning(this.$t('toasts_message.enum_error', {key: key, allowed_values: header[i].enum.join(", ")}))
                shouldBreak = true
                break
              }
              let value = header[i].type === "number" ? parseInt(String(item[key]).trim()) : String(item[key]).trim()
              returnStr[header[i].key] = value
            }
            if (shouldBreak) break
            result.push(returnStr)
          }
          if (shouldBreak) break
        }

        if (!shouldBreak) {
          if (result.length < 1) {
            this.$awn.warning(this.$t('toasts_message.excel_no_data'))
            return
          }
          var itemList = JSON.stringify(result)
          DepartmentExcelUploadAPI.post("", itemList)
            .then(resp => {
              let total = resp.data.objects.total_count
              let failure = resp.data.objects.failed_count
              this.$awn.success(this.$t('toasts_message.department_bulk_register', {failure: failure}))
              this.excelAdd = false
              this.fetchList()
            })
            .catch(e => {
              console.log(e)
            })
        }
      }
      if (input.files[0]) {
        reader.readAsBinaryString(input.files[0])
      } else {
        this.$awn.warning(this.$t('toasts_message.select_file'))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  background-color: transparent;
  margin: 0;
  padding: 0 0 0.5rem;
  color: black !important;
  font-size: 1.2rem;
  font-weight: 500;
  .breadcrumb-item.active {
    color: black !important;
  }
}
.edit {
  position: relative;
  a {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1px;
  }
}
.editable-wrapper.hidden::v-deep {
  input {
    color: transparent;
  }
}
</style>
